import IconNext from "@/assets/icons/common/icon-next.svg";
import ArrowRight from "@/assets/icons/common/arrow-right.svg";
import DeletePurple from "@/assets/icons/common/delete-purple.svg";
import GrainCoffee from "@/assets/icons/common/grain-coffee.svg";
import Success from "@/assets/icons/common/success.svg";
import Mail from "@/assets/icons/contact/mail.svg";
import Phone from "@/assets/icons/contact/phone.svg";
import Instagram from "@/assets/icons/network/instagram.svg";
import Facebook from "@/assets/icons/network/facebook.svg";
import WhatsApp from "@/assets/icons/network/whatsapp.svg";
import YouTube from "@/assets/icons/network/youtube.svg";
import Store1 from "@/assets/icons/store/store_1.png";
import Store2 from "@/assets/icons/store/store_2.png";
import Basket1 from "@/assets/icons/store/basket_1.png";
import Basket2 from "@/assets/icons/store/basket_2.png";
import CoffeeMug from "@/assets/icons/store/coffee-mug.svg";
import CoffeeShopPurple from "@/assets/icons/store/coffee-shop-purple.svg";
import CoffeeBag from "@/assets/icons/store/coffee-bag.svg";
import CoffeeCup from "@/assets/icons/store/coffee-cup.svg";
import CoffeeGrainBeigePurple from "@/assets/icons/store/coffee-grain-beige-purple.svg";
import CoffeeGrainPurpleBeige from "@/assets/icons/store/coffee-grain-purple-beige.svg";
import CoffeeReact from "@/assets/icons/store/coffee-react.png";
import CoffeeShop from "@/assets/icons/store/coffee-shop.png";
import FilterBlack from "@/assets/icons/store/filter-black.svg";
import FilterPurple from "@/assets/icons/store/filter-purple.svg";
const common = {
    IconNext,
    ArrowRight,
    DeletePurple,
    GrainCoffee,
    Success,
};
const contact = {
    Mail,
    Phone,
};
const network = {
    Instagram,
    Facebook,
    WhatsApp,
    YouTube,
};
const store = {
    Store1,
    Store2,
    Basket1,
    Basket2,
    FilterBlack,
    FilterPurple,
    CoffeeMug,
    CoffeeShopPurple,
    CoffeeBag,
    CoffeeCup,
    CoffeeGrainBeigePurple,
    CoffeeGrainPurpleBeige,
    CoffeeReact,
    CoffeeShop,
};
export const icons = {
    ...common,
    ...contact,
    ...network,
    ...store,
};
